const KEY = "yaojing-fav-anime";

export function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeFavorites(ids: string[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    // ignore storage failure (private mode etc.)
  }
}

export function isFavorite(id: string): boolean {
  return readFavorites().includes(id);
}

export function toggleFavorite(id: string): boolean {
  const list = readFavorites();
  const next = list.includes(id) ? list.filter((item) => item !== id) : [...list, id];
  writeFavorites(next);
  return next.includes(id);
}